module.exports = __webpack_public_path__ + "img/up12.704d622c.png";